// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__38B8J","validationTips":"StatementDescriptor_validationTips__2KTQY"};